import { useInfiniteQuery } from 'react-query';
import client from 'client';

export default () => {
  const fetchInboxMessages = ({ pageParam = 1, queryKey }) => {
    const method = queryKey[0];
    const url = queryKey[1];
    const params = queryKey[2];
    return client.request({
      method,
      url,
      params: { ...params, page: pageParam },
    });
  };

  const { data, isLoading, fetchNextPage, isFetchingNextPage, hasNextPage, isSuccess } = useInfiniteQuery(['GET', '/apis/v2/messages/inbox', { per: 10 }], fetchInboxMessages, {
    getNextPageParam: (lastPage) => {
      if (!lastPage.data) {
        return 1;
      }
      if (lastPage.data.meta.page === lastPage.data.meta.totalPages) {
        return undefined;
      }
      if (lastPage.data) {
        return lastPage.data.meta.page + 1;
      }
      return 1;
    },
    getPreviousPageParam: (firstPage) => (firstPage.data?.meta ? firstPage.data.meta.page - 1 : 1),
  });
  const joinedArrays = (data?.pages?.map((page) => page.data?.data).flat(1) || []).filter((n) => n);
  return { data: joinedArrays, isLoading, fetchNextPage, hasNextPage, isFetching: isLoading, isFetchingNextPage, total: joinedArrays.length, isSuccess };
};
